export default {"src":"/_next/static/image/public/assets/icons/full-star.fb96679e5adeccfb1f017c09579ae1fd.svg","height":16,"width":16};